import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

function guardMyroute(to, from, next) {
  let isAuthenticated = false;
  // this is just an example. You will have to find a better or
  // centralised way to handle you localstorage data handling
  if (localStorage.userID) {
    isAuthenticated = true;
  } else isAuthenticated = false;
  if (isAuthenticated) {
    next(); // allow to enter route
  } else {
    next({ name: 'Login' }); // go to '/login';
  }
}

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  // base: window.location.pathname, //is this important for building?
  routes: [
    {
      path: '/signup',
      name: 'Signup',
      component: () => import('../components/Signup.vue'),
    },
    {
      path: '/login',
      name: 'Login',
      component: () => import('../components/Login.vue'),
    },
    {
      path: '/logout',
      name: 'Logout',
      component: () => import('../components/Logout.vue'),
    },
    // {
    //   path: '/demo',
    //   beforeEnter: guardMyroute,
    //   name: 'Demo',
    //   component: () => import('../components/Demo.vue'),
    // },
    {
      path: '/questions',
      beforeEnter: guardMyroute,
      name: 'Questions',
      component: () => import('../components/Questions.vue'),
    },
    {
      path: '/',
      name: 'Home',
      component: () => import('../components/Home.vue'),
    },
  ],
});
export default router;
